import { css } from "lit";
import { Style } from "../Styles";

export const styles = css`
    ${Style}
    :host {
        display: block;
    }

    .container sl-button {
        width: 100%;
    }

    .button-bar {
        justify-content: space-between;
        width: 100%;
        align-items: center;
    }

    sl-icon-button {
        font-size: 1.5em;
        margin-left: 0.3em;
        margin-right: 0.3em;
    }

    ds-place-editor {
        height: 60vh;
    }
`;
